import React from 'react';

interface MultiCheckProps {
  active?: boolean;
  onClick?: () => void;
  activeColor?: string;
}

/**
 * MultiCheck icon component
 *
 * @param active - Whether the icon is in active state (default: false)
 * @param onClick - Click handler function
 */
const MultiCheck: React.FC<MultiCheckProps> = ({
  active = false,
  onClick,
  activeColor,
}) => (
  <svg
    className='multi-check'
    width={16}
    height={16}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    onClick={onClick}
    tabIndex={0} // focusable
    role='button'
    aria-pressed={active} // accessibility state
    onKeyDown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onClick?.();
      }
    }}
    style={{ cursor: 'pointer' }}
  >
    <path
      d='M13.3334 1.33337H5.33337C4.60004 1.33337 4.00004 1.93337 4.00004 2.66671V10.6667C4.00004 11.4 4.60004 12 5.33337 12H13.3334C14.0667 12 14.6667 11.4 14.6667 10.6667V2.66671C14.6667 1.93337 14.0667 1.33337 13.3334 1.33337ZM8.31337 9.33337L6.00004 7.00004L6.93337 6.06004L8.31337 7.44671L11.7334 4.00004L12.6667 4.94004L8.31337 9.33337ZM2.66671 4.00004H1.33337V13.3334C1.33337 14.0667 1.93337 14.6667 2.66671 14.6667H12V13.3334H2.66671V4.00004Z'
      fill={active ? '#266EF1' : activeColor}
    />
  </svg>
);

export default MultiCheck;
